<template>
  <CRow>
    <CCol>
      <CCard>
        <CCardHeader>Detail Member POS</CCardHeader>
        <CCardBody class="ml-4">
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="POS Code"
                class="mb-0"
                type="text"
                required
                vertical
                disabled
                v-model="dataMemberPOS.pos_code"
                placeholder="POS Code"
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="POS Name"
                class="mb-0"
                type="text"
                required
                vertical
                v-model="dataMemberPOS.pos_name"
                :disabled="isDetail"
                placeholder="POS Name"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Email"
                class="mb-0"
                type="text"
                required
                vertical
                v-model="dataMemberPOS.email"
                :disabled="isDetail"
                placeholder="Email"
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Status"
                class="mb-0"
                type="text"
                required
                vertical
                v-if="isDetail"
                v-model="dataMemberPOS.status"
                :disabled="isDetail"
                placeholder="Created At"
              />
              <CSelect
                label="Status"
                :options="options"
                type="options"
                v-model="dataMemberPOS.status"
                vertical
                v-else
                required
                @change="handleStatus"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Created At"
                class="mb-0"
                type="text"
                required
                vertical
                v-if="isDetail"
                v-model="dataMemberPOS.created_at"
                :disabled="isDetail"
                placeholder="Created At"
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Updated At"
                class="mb-0"
                type="text"
                required
                vertical
                v-if="isDetail"
                v-model="dataMemberPOS.updated_at"
                :disabled="isDetail"
                placeholder="Updated At"
              />
            </CCol>
          </CRow>
          <CRow class="btn-member-pos">
            <CButton color="primary" @click="goBack">Back</CButton>
            <CButton v-if="!isDetail" color="success" @click="update"
              >Update</CButton
            >
          </CRow>
        </CCardBody>
        <CCardFooter class="ml-4">
          <UsernamePOSTable
            :data="dataMemberPOS.pos_data"
            :memberPOSID="dataMemberPOS.id"
            :isDetail="isDetail"
          />
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
// import usersData from './UsersData'
import axios from "axios";
import jwt from "jsonwebtoken";
import UsernamePOSTable from "./UsernamePOS.vue";
import moment from "moment";
import Swal from "sweetalert2";
export default {
  components: {
    UsernamePOSTable,
  },
  name: "MemberPOS",
  data() {
    return {
      dataMemberPOS: {},
      dataMemberPOSUpdate: {
        email: "",
        pos_name: "",
        pos_code: "",
        status: "",
      },
      isDetail: false,
      domain: process.env.VUE_APP_DOMAIN_URL,
      options: ["ACTIVE", "INACTIVE"],
      token: "Bearer " + localStorage.getItem("token"),
    };
  },
  beforeMount() {
    this.authentication();
    if (
      this.$router.currentRoute.path.includes("/management/member-pos/detail")
    ) {
      this.isDetail = true;
    } else if (
      this.$router.currentRoute.path.includes("/management/member-pos/edit")
    ) {
      this.isDetail = false;
    }
    this.getMemberPOSData();
  },
  methods: {
    pageChange(val) {
      this.$router.push({ query: { page: val } });
    },
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
        data.account_group === "NPOS" ||
        data.account_group === "ADMIN" ||
        data.account_group === "ADMINISTRATOR"
      ) {
        return null;
      } else {
        this.$router.push({ path: `/` });
      }
    },
    getMemberPOSData() {
      axios
        .get(`${this.domain}/v1/pos/account/${this.$route.params.id}`, {
          headers: {
            Authorization: this.token,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          this.dataMemberPOS = response.data;
          this.dataMemberPOS.created_at = moment(
            this.dataMemberPOS.created_at
          ).format("MM/DD/YYYY HH:mm:ss");
          this.dataMemberPOS.updated_at = moment(
            this.dataMemberPOS.updated_at
          ).format("MM/DD/YYYY HH:mm:ss");
          this.dataMemberPOS.pos_data.map((item) => {
            item.created_at = moment(item.created_at).format(
              "MM/DD/YYYY HH:mm:ss"
            );
          });
        })
        .catch(() => {
          Swal.fire({
            icon: "error",
            title: "Gagal mendapatkan data member POS",
            showConfirmButton: false,
            timer: 2000,
          });
        });
    },
    handleStatus(event) {
      this.dataMemberPOS.status = event.target.value;
    },
    update() {
      this.dataMemberPOSUpdate.pos_name = this.dataMemberPOS.pos_name;
      this.dataMemberPOSUpdate.pos_code = this.dataMemberPOS.pos_code;
      this.dataMemberPOSUpdate.status = this.dataMemberPOS.status;
      this.dataMemberPOSUpdate.email = this.dataMemberPOS.email;
      axios
        .put(
          `${this.domain}/v1/pos/account/${this.dataMemberPOS.id}`,
          this.dataMemberPOSUpdate,
          {
            headers: {
              Authorization: this.token,
              "Content-Type": "application/json",
            },
          }
        )
        .then(() => {
          Swal.fire({
            icon: "success",
            title: "Data member POS diupdate",
            showConfirmButton: false,
            timer: 2000,
          });
          this.$router.push({ path: `/management/member-pos/list` });
        })
        .catch(() => {
          Swal.fire({
            icon: "error",
            title: "Gagal update data member POS",
            showConfirmButton: false,
            timer: 2000,
          });
        });
    },
    goBack() {
      this.$router.push("/management/member-pos/list");
    },
  },
};
</script>

<style scoped>
@import url("./MemberPOS.css");
</style>
